import { createReducer } from "@reduxjs/toolkit";

import {
  addCard,
  addCardSuccess,
  addCardFailure,
  getCards,
  getCardsSuccess,
  getCardsFailure,
  deleteCard,
  deleteCardSuccess,
  deleteCardFailure,
} from "./actions";

const initialState = {
  allCards: [],
  cardsById: {},
  isLoading: false,
  isAdding: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getCards.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getCardsSuccess.type, (state, { payload }) => {
      const { result, cards } = payload;

      state.cardsById = cards ?? {};
      state.allCards = result;
      state.isLoading = false;
    })
    .addCase(getCardsFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(addCard.type, (state) => {
      state.isAdding = true;
    })
    .addCase(addCardSuccess.type, (state, { payload }) => {
      const { id } = payload;
      const nextCards = {};
      const { cardsById = {} } = state;

      Object.entries?.(cardsById)?.forEach(([key, value]) => {
        nextCards[key] = { ...value, isDefault: false };
      });

      state.cardsById = { ...nextCards, [id]: payload };
      state.allCards = [id, ...state.allCards];
      state.isAdding = false;
    })
    .addCase(addCardFailure.type, (state) => {
      state.isAdding = false;
    })
    .addCase(deleteCard.type, (state, { payload }) => {
      const { id } = payload;

      state.cardsById[id].isDeleting = true;
    })
    .addCase(deleteCardSuccess.type, (state, { payload }) => {
      const { id } = payload;

      state.allCards = state.allCards.filter((cardId) => cardId != id);
      delete state.cardsById[id];
    })
    .addCase(deleteCardFailure.type, (state, { payload }) => {
      const { id } = payload;

      state.cardsById[id].isDeleting = false;
    });
});
